export enum ELSTR_BACKEND_VERSION {
  BE1 = "BE1",
  BE2 = "BE2",
}
